import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { observer } from 'mobx-react';
import FormStore, { NoFields } from '~/lib/store/FormStore';
import { getAppContext } from '~/lib/AppContext';
import { isProblemDetails } from '~/lib/helper/ErrorHelper';

interface ConfirmEmailProps {
    id: string;
}

@observer
export default class ConfirmEmail extends React.Component<ConfirmEmailProps> {
    form = new FormStore<NoFields>({});

    componentDidMount() {
        void this.confirmEmail();
    }

    async confirmEmail() {
        await this.form.doSubmit(
            async () => {
                await getAppContext().siteApiClient.confirmEmail(this.props.id);
            },
            { suppressErrorModal: true }
        );
    }

    renderStatus() {
        const canCloseWithScript = !!window.opener || window.history.length === 1;

        if (this.form.isSubmitting)
            return (
                <>
                    <h3 className="mb-4">Confirming your email...</h3>
                    <Spinner size="sm" color="primary" className="me-2" />
                    <p className="mb-3">Please wait while we confirm your email address.</p>
                </>
            );

        if (this.form.lastError) {
            const error = this.form.lastError;
            const reason = isProblemDetails(error)
                ? (error.detail ?? error.title)
                : 'We could not confirm your email address. Please try again.';
            return (
                <>
                    <div role="alert">
                        <h3 className="mb-4">Email Confirmation Failed</h3>
                        {reason && <p className="mb-3">{reason}</p>}
                    </div>
                    {canCloseWithScript && (
                        <Button color="primary" className="mt-4" onClick={() => window.close()}>
                            Close Window
                        </Button>
                    )}
                </>
            );
        } else {
            return (
                <>
                    <h3 className="mb-4">Thank you!</h3>
                    <p className="mb-3">Your email has been confirmed successfully. This window may now be closed.</p>
                    {canCloseWithScript && (
                        <Button color="primary" className="mt-4" onClick={() => window.close()}>
                            Close Window
                        </Button>
                    )}
                </>
            );
        }
    }

    render() {
        return <div className="confirmEmail text-center py-4">{this.renderStatus()}</div>;
    }
}
